import { Divider, List, Modal, Progress } from 'antd';
import KPageHeader from 'common/component/KPageHeader';
import KSpinner from 'common/component/KSpinner';
import { AbsentModel } from 'data/absent/absent.model';
import { useGrade } from 'features/routine/hooks/useGrade';
import moment from 'moment';
import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useDashboard } from '../hooks/useDashboard';
import { AbsentViewWrapper, DashboardWrapper } from './dashboard.style';

interface Props {}

interface Absent {
  grade: string;
  section: string;
  absentCount: number;
}

const DashBoardView: React.FC<Props> = () => {
  const { fetchAbsentStudents, fetchAbsentStudentsByGrade } = useDashboard();
  const { fetchGrade } = useGrade();
  const grade = useSelector((state: RootState) => state.grade);
  const absentstudents = useSelector((state: RootState) => state.absent);
  const absentStudentsByGrade = useSelector((state: RootState) => state.absentByGrade);
  const absentView: Absent[] = [];
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  let absentCount = 0;

  grade.data.map((eachGrade) => {
    eachGrade.sections.map((section) => {
      absentstudents.data.map((absentee) => {
        if (
          eachGrade.id === absentee.student.gradeId &&
          section.id === absentee.student.sectionId
          // &&  absentee.date === moment().toString()
        ) {
          absentCount += 1;
        }
      });
      if (absentCount !== 0) {
        absentView.push({ grade: eachGrade.id, section: section.id, absentCount: absentCount });
        absentCount = 0;
      }
    });
  });

  const handleAbsentDetails = (grade: string, section: string) => {
    fetchAbsentStudentsByGrade(grade, section);
    setIsModalVisible(true);
  };

  React.useEffect(() => {
    fetchGrade();
    fetchAbsentStudents();
  }, []);

  return (
    <DashboardWrapper>
      <KPageHeader title="DashBoard" />
      <AbsentViewWrapper>
        <div className="title">Attendance</div>
        <Divider style={{ marginTop: 'var(--gap)', marginBottom: 'var(--gap)' }} />
        <section>
          <div className="header">
            <div className="sub-header">Grade</div>
            <div className="sub-header">Absent</div>
          </div>
          {absentView.map((absent) => (
            <div
              className="data-list"
              onClick={() => handleAbsentDetails(absent.grade, absent.section)}
            >
              <div className="sub-title">
                {absent.grade} '{absent.section}'
              </div>
              <div className="sub-title">{absent.absentCount}</div>
            </div>
          ))}
          <Modal
            title="Absent Students"
            visible={isModalVisible}
            onOk={() => setIsModalVisible(false)}
            onCancel={() => setIsModalVisible(false)}
          >
            {absentStudentsByGrade.status === 'loading' && <KSpinner />}
            {absentStudentsByGrade.status === 'data' && (
              <List
                size="small"
                bordered
                dataSource={absentStudentsByGrade.data}
                renderItem={(item) => <List.Item>{item.student.__user__.full_name}</List.Item>}
              />
            )}
          </Modal>
        </section>
      </AbsentViewWrapper>
    </DashboardWrapper>
  );
};

export default DashBoardView;
